import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useGetExamTypes({ boardId, enabled = false } = {}) {
  const { privateFetch } = useContext(FetchContext);

  return useQuery(
    ['exam-types', boardId],
    () =>
      privateFetch
        .get(`/v1/admin/manage-podcasts/exam-info/boards/${boardId}/exam-types`)
        .then((r) => r.data),
    { enabled: enabled && !!boardId, keepPreviousData: true }
  );
}

export default useGetExamTypes;
